import React from 'react';
import { TicketSelector } from '../../../../../../surveys/containers/SurveyResponses/EventRegistration/components/EventSurvey/EventSurveyForm/components/TicketSelector';
import { IEventTicket, TicketSortMode } from '../../../../../../surveys/models/Api';
import { sortEventTicketsForDisplay } from './sortEventTicketsForDisplay';

interface PreviewTicketSelectorProps {
	tickets: IEventTicket[];
	selections: Record<string, number>;
	onSelectionChange: (ticketId: string, quantity: number) => void;
	minQuantities?: Record<string, number>;
	sortMode?: TicketSortMode;
}

/**
 * Preview wrapper for TicketSelector component
 * Allows ticket selection changes for preview (to show dynamic ticket holder updates)
 * Individual ticket holder fields remain disabled in TicketHolderFields component
 *
 * Sorts locally since the preview has no server round-trip (TicketSelector itself doesn't sort).
 */
export const PreviewTicketSelector: React.FC<PreviewTicketSelectorProps> = ({
	tickets,
	selections,
	onSelectionChange,
	minQuantities = {},
	sortMode,
}) => {
	const sortedTickets = React.useMemo(() => sortEventTicketsForDisplay(tickets, sortMode), [tickets, sortMode]);

	return (
		<TicketSelector
			tickets={sortedTickets}
			selections={selections}
			onSelectionChange={onSelectionChange}
			minQuantities={minQuantities}
			disabled={false}
		/>
	);
};
